<template>
  <div>
    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>
    <div class="dataTable__buttonLink text-right mb-2" style="position: relative">
      <CButton class="px-4 py-2" color="primary" tag="button" @click="exportPopup = true">
        {{ $t('transaction.history.button.export') }}
        <CIcon name="arrowExport" size="custom-size" :height="18" class="ml-2" viewBox="0 0 32 32" />
      </CButton>
      <transition name="fade" v-if="exportPopup">
        <div class="dataTable__popUp popUp" style="right: 0; left: unset" @click.stop.stop>
          <div class="popUp__body shadow-sm">
            <ChooseExport v-if="!loadingExport" @confirm="exportRecods($event)" @cancel="closePopupExport" />
            <LoadingSpinner v-else size="sm" />
            <div class="blocker" @click="closePopupExport"></div>
          </div>
        </div>
      </transition>
    </div>

    <SenditTable
      :headers="headers"
      :registers="registers"
      :loading="loading"
      :itemsPerPage="itemsPerPage"
      :currentPage="currentPage"
      :totalPages="totalPages"
      :pagination="registers.length > 0"
      searchable
      expandable
      :expandText="[$t('transational.logs.expandLabel.expand'), $t('transational.logs.expandLabel.collapse')]"
      searchPlaceholder="Search"
      :searchTime="1500"
      @updatePage="atualizandoPage"
      @search="search"
      searchClasses="search-padding"
      :noData="!hasFilter && !hasRegister"
    >
      <template #filters-top> </template>
      <template #filters-right>
        <div class="justify-content-end">
          <CRow>
            <CCol>
              <label class="mb-0 mr-3"> {{ $t('transational.logs.originType') }}: </label>
              <v-select
                class="no-close newInput"
                :options="originTypeOptions"
                v-model="originTypeSelected"
                @option:selected="udpateOriginTypeFilter"
                placeholder="Select"
              >
              </v-select>
            </CCol>
            <CCol>
              <label class="mb-0 mr-3"> {{ $t('transational.logs.filterBy') }}: </label>
              <v-select
                class="no-close newInput"
                :options="filterByOptions"
                v-model="filterByOptionsSelected"
                @option:selected="updateTableFilterBy"
                placeholder="Select"
              >
              </v-select>
            </CCol>
            <CCol>
              <form @submit.prevent class="">
                <label for="Select period" class="mb-0 mr-3">{{ $t('transational.logs.selectPeriod') }}: </label>
                <v-date-picker
                  mode="range"
                  color="purple"
                  timezone="UTC"
                  is-range
                  addInputClas
                  ses="newInput"
                  :value="range"
                  :locale="lang"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @input="updateTablePeriod"
                >
                  <template v-slot="{ inputValue, inputEvents, showPopover, hidePopover }">
                    <CInput
                      :value="rangeFormatted"
                      class="dateInputCustom newInput px-0 text-left inputAppendCustom inputAppendCustom--transparent"
                      add-input-classes="pr-0"
                      v-on="inputEvents"
                      readonly
                      style="min-width: 260px; background-color: white"
                      @mouseover="showPopover"
                      @mouseleave="hidePopover"
                    >
                      <template #append-content>
                        <span @click="clearRange" class="pr-none">
                          <CIcon
                            v-if="inputValue"
                            class="btn-value mt-2 text-center"
                            name="cilXCircle"
                            size="custom-size"
                            :height="23"
                            viewBox="0 0 32 32"
                          />
                        </span>
                      </template>
                    </CInput>
                  </template>
                </v-date-picker>
              </form>
            </CCol>
          </CRow>
          <!-- <form @submit.prevent class="d-flex content-center p-0 m-0 mr-5">
            <label class="mb-0 mr-3"> {{ $t('transational.logs.filterBy') }}: </label>
            <v-select
              class="no-close newInput"
              :options="filterByOptions"
              v-model="filterByOptionsSelected"
              @option:selected="updateTableFilterBy"
              placeholder="Select"
            >
            </v-select>
          </form>

          <form @submit.prevent class="d-flex content-center p-0 m-0">
            <label for="Select period" class="mb-0 mr-3">{{ $t('transational.logs.selectPeriod') }}: </label>
            <v-date-picker
              mode="range"
              color="purple"
              timezone="UTC"
              is-range
              addInputClas
              ses="newInput"
              :value="range"
              :locale="lang"
              :min-date="minDate"
              :max-date="maxDate"
              @input="updateTablePeriod"
            >
              <template v-slot="{ inputValue, inputEvents, showPopover, hidePopover }">
                <CInput
                  :value="rangeFormatted"
                  class="dateInputCustom newInput px-0 text-left inputAppendCustom inputAppendCustom--transparent"
                  add-input-classes="pr-0"
                  v-on="inputEvents"
                  readonly
                  style="min-width: 260px; background-color: white"
                  @mouseover="showPopover"
                  @mouseleave="hidePopover"
                >
                  <template #append-content>
                    <span @click="clearRange" class="pr-none">
                      <CIcon
                        v-if="inputValue"
                        class="btn-value mt-2 text-center"
                        name="cilXCircle"
                        size="custom-size"
                        :height="23"
                        viewBox="0 0 32 32"
                      />
                    </span>
                  </template>
                </CInput>
              </template>
            </v-date-picker>
          </form> -->
        </div>
      </template>
      <template #footer-left>
        <div class="d-flex flex-column justify-content-center" v-if="registers.length > 0">
          <p class="m-0">
            <CIcon name="recover" size="custom-size" class="mr-2" :height="25" viewBox="0 0 32 32" />
            {{ $t('transational.logs.table.text.registers') }}
          </p>
        </div>
      </template>

      <template #sent="{ item }">
        <td>{{ handleDate(item.sent) }}</td>
      </template>

      <template #originType="{ item }">
        <td>{{ $t(originTypeHandler(item.originType)) }}</td>
      </template>

      <template #countryId="{ item }">
        <td>
          <img :src="getFlag(item.countryId).flag" width="25" height="auto" class="mr-2" />
          {{ getFlag(item.countryId).label }}
        </td>
      </template>

      <template #status="{ item }">
        <td>
          <CIcon
            v-if="item.status == 3"
            name="notificationAlert"
            class="m-0 p-0"
            :class="handleStatus(item.status).status"
            :height="14"
            size="custom-size"
            viewBox="0 0 32 32"
          />
          <span :class="handleStatus(item.status).status" class="text-uppercase font-weight-bold font-sm">
            {{ handleStatus(item.status).label }}
          </span>
        </td>
      </template>

      <template #attachments="{ item }">
        <td>{{ item.emailAttachments.length }}</td>
      </template>

      <template #expanded-area="{ item }">
        <div class="text-gray-600">
          <h5 class="text-gray-base mt-1 mb-4">{{ $t(`transational.logs.expanded.title`) }}</h5>
          <table class="table table--detail">
            <tbody>
              <tr v-for="element in headers" :key="element.key">
                <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300" style="width: 300px">
                  {{ $t(`transational.logs.headers.${element.key}`) }}
                </td>
                <td v-if="element.label == 'status'" class="px-4 border border-gray-300">
                  <CIcon
                    v-if="item.status == 3"
                    name="notificationAlert"
                    class="m-0 p-0"
                    :class="handleStatus(item.status).status"
                    size="custom-size"
                    :height="14"
                    viewBox="0 0 32 32"
                  />
                  <span :class="handleStatus(item.status).status" class="text-uppercase font-weight-bold font-sm">
                    {{ handleStatus(item.status).label }}
                  </span>
                </td>
                <td
                  v-else-if="element.label == 'attachments' && item.emailAttachments && item.emailAttachments.length > 0"
                  class="px-4 border border-gray-300"
                >
                  <div class="d-flex gap-15">
                    <CustomTooltip v-for="attachment in item.emailAttachments" :key="attachment.id" placement="right">
                      <div @click="downloadEmailAttachment(item, attachment.id)" class="d-flex align-items-center text-underline">
                        <CIcon name="cilFile" size="sm" viewBox="0 0 32 32" />
                        <span class="text-nowrap">{{ attachment.name }}</span>
                        <CSpinner
                          v-if="attachmentLoadingStates[`${item.id}-${attachment.id}`]"
                          class="ml-1"
                          color="primary"
                          style="width: 1rem; height: 1rem"
                        />
                      </div>
                      <template v-slot:content>
                        <div>
                          <span class="font-weight-bold">{{ $t(`transational.logs.attachments.type`) }}:</span>
                          {{ attachment.mimeType }}
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ $t(`transational.logs.attachments.size`) }}:</span>
                          {{ getFormattedAttachmentSize(attachment.sizeInBytes) }}
                        </div>
                      </template>
                    </CustomTooltip>
                  </div>
                  <div class="text-warning" v-if="isItemAttachmentExpired(item.attachmentExpirationDatetime)">
                    {{ $t(`transational.logs.attachments.unavailable`) }}
                  </div>
                </td>
                <td v-else class="px-4 border border-gray-300">
                  {{ handlerValueTable(element.label, item[element.key]) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </SenditTable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import MenssageAlert from '@/components/MenssageAlert'
import CustomTooltip from '@/components/CustomTooltip.vue'
import SenditTable from '@/components/table/SenditTable.vue'
import { dateFormatStringFull, dateFormatStringMed, dateTimeFormatString, getUserDateFormat } from '@/utils/dateUtil'
import { nameCountries } from '@/utils/countriesUtils.js'
import { formatFileSize } from '@/utils/numbersFormatUtil.js'
import services from '@/services.js'
import { getFilenameFromContentDisposition } from '@/utils/responseHeaderUtils'
import fileDownload from 'js-file-download'
import { DateTime } from 'luxon'
import ChooseExport from '@/components/ChooseExport'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const TransactionalOriginTypeEnum = {
  1: 'transactional',
  2: 'zapier',
  3: 'quick',
}

const statusEMAIL = {
  1: 'sent',
  2: 'span',
  3: 'bounced',
}
export default {
  components: {
    SenditTable,
    vSelect,
    MenssageAlert,
    CustomTooltip,
    ChooseExport,
    LoadingSpinner,
  },

  data() {
    return {
      exportPopup: false,
      loadingExport: false,
      registers: [],
      headers: [],
      itemsPerPage: 10,
      totalRegisters: null,
      currentPage: 1,
      totalPages: null,
      searched: '',
      loading: false,
      selectedItems: [],
      propsHeaders: [],
      requestOptions: {},
      table: 'email',
      filters: {
        Page: 1,
        Count: 10,
        email: null,
        Status: null,
        IniDate: null,
        EndDate: null,
      },
      filterByOptions: [
        { label: this.$t('transational.logs.filters.all'), key: null },
        { label: this.$t('transational.logs.filters.sent'), key: 1 },
        { label: this.$t('transational.logs.filters.spam'), key: 2 },
        { label: this.$t('transational.logs.filters.bounced'), key: 3 },
      ],
      filterByOptionsSelected: { label: 'All', key: null },
      originTypeOptions: [
        { label: this.$t('transational.logs.filters.all'), key: null },
        { label: this.$t('transational.logs.transactionStatus.transactional'), key: 1 },
        { label: this.$t('transational.logs.transactionStatus.zapier'), key: 2 },
      ],
      originTypeSelected: { label: this.$t('transational.logs.filters.all'), key: null },
      range: undefined,
      masks: {
        input: 'YYYY-MM-DD',
      },
      messages: [],
      organizationId: null,
      attachmentLoadingStates: {},
    }
  },

  created() {
    this.organizationId = this.$route.params.organizationId

    this.headers = [
      {
        key: 'recipient',
        label: 'recipient',
      },
      {
        key: 'from',
        label: 'from',
      },
      {
        key: 'originType',
        label: 'originType',
      },
      {
        key: 'sent',
        label: 'sent',
      },

      {
        key: 'subject',
        label: 'subject',
      },
      {
        key: 'opens',
        label: 'opens',
      },
      {
        key: 'clicks',
        label: 'clicks',
      },
      {
        key: 'status',
        label: 'status',
      },
      {
        key: 'attachments',
        label: 'attachments',
      },
    ]

    this.range = {
      start: DateTime.utc().minus({ days: 7 }).startOf('day').toISO(),
      end: this.maxDate,
    }

    this.filters.IniDate = this.range.start
    this.filters.EndDate = this.range.end
  },

  mounted() {
    this.getData()
  },

  update() {
    this.getData()
  },

  computed: {
    minDate() {
      return DateTime.utc().minus({ days: 90 }).startOf('day').toISO()
    },
    maxDate() {
      return DateTime.utc().endOf('day').toISO()
    },
    contentTable() {
      return statusEMAIL
    },

    hasRegister() {
      return Boolean(this.registers.length)
    },

    hasFilter() {
      return this.searched != '' || this.filterByOptionsSelected != null || this.range != null
    },

    rangeFormatted() {
      if (!this.hasRange) return null

      const userDateTimeFormat = getUserDateFormat(this.$store.state.auth.user.dateTimeFormat)

      const formattedStart = DateTime.fromISO(this.range.start).setZone('UTC').toFormat(userDateTimeFormat)
      const formattedEnd = DateTime.fromISO(this.range.end).setZone('UTC').toFormat(userDateTimeFormat)

      return `${formattedStart} - ${formattedEnd}`
    },

    hasRange() {
      return Boolean(this.range && this.range.start && this.range.end)
    },

    ...mapGetters({
      lang: 'getLang',
    }),
  },

  methods: {
    closePopupExport() {
      this.exportPopup = false
    },

    originTypeHandler(value) {
      return `transational.logs.transactionStatus.${TransactionalOriginTypeEnum[value]}` || ''
    },

    exportRecods(events) {
      this.messages = []
      let organizationId = this.$route.params.organizationId
      let filters = this.filters
      delete filters.Count
      delete filters.Page

      this.loadingExport = true
      filters.format = events.format

      if (events.format == 2) filters.delimiter = events.delimiter

      services
        .getEmailTransactionsExport(organizationId, filters)
        .then((response) => {
          const nameFile = getFilenameFromContentDisposition(response.headers['content-disposition'])

          fileDownload(response.data, nameFile, response.headers['content-type'])
          this.exportPopup = false
        })
        .catch(async ({ response }) => {
          if (response && response.data instanceof Blob) {
            const text = await response.data.text()
            const errorData = JSON.parse(text)

            this.messages.push({
              status: 'danger',
              text: this.$t(`general.errors.${errorData.errorMessage}`),
            })
          }
        })
        .finally(() => {
          this.loadingExport = false
        })
    },

    clearRange() {
      this.range = {
        start: null,
        end: null,
      }

      this.filters.IniDate = null
      this.filters.EndDate = null
    },
    // minDate(daysAgo = 90) {
    //   let date = new Date()
    //   date.setDate(date.getDate() - daysAgo)
    //   return date.toISOString().split('T')[0]
    // },
    // maxDate() {
    //   const max = new Date()
    //   return max
    // },
    getFlag(data) {
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == data.toUpperCase())
      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },
    atualizandoPage(newPage) {
      this.filters.Page = newPage
      this.getData()
      // this.currentPage = newPage
    },
    selecionarLinha(linha) {
      this.selectedItems = linha
    },
    search(value) {
      this.searched = value
      this.filters.email = value
      this.filters.Page = 1

      this.getData()
    },
    updateTablePeriod(inputValue) {
      if (!inputValue?.start || !inputValue?.end) return

      this.range = {
        start: DateTime.fromJSDate(inputValue.start).setZone('UTC').startOf('day').toISO(),
        end: DateTime.fromJSDate(inputValue.end).setZone('UTC').endOf('day').toISO(),
      }

      this.filters.IniDate = this.range.start
      this.filters.EndDate = this.range.end

      this.filters.Page = 1

      this.getData()
    },

    udpateOriginTypeFilter(value) {
      this.filters.OriginType = value.key
      this.filters.Page = 1

      this.getData()
    },

    updateTableFilterBy(value) {
      this.filterByOptionsSelected = value
      this.filters.Status = value.key

      this.filters.Page = 1

      this.getData()
    },
    opt(data) {
      return dateTimeFormatString(data)
    },
    getData() {
      this.loading = true

      services
        // .getCampaignsTransactions('de07f552-21d6-4acc-ba04-805bc87c78ef', 'email', this.filters)
        .getCampaignsTransactions(this.organizationId, 'email', this.filters)
        .then((resp) => {
          const pagination = resp.data.data.pagination
          const dataList = resp.data.data.emailTransactions || []

          this.totalRegisters = pagination.totalRecords
          this.currentPage = pagination.currentPage
          this.totalPages = pagination.totalPages

          this.registers = dataList
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleDate(item) {
      return item ? dateFormatStringFull(item) : dateFormatStringMed(item)
    },

    handleStatus(statusCode) {
      if (typeof statusCode != 'number') {
        return statusCode
      }

      const positions = {
        1: {
          status: 'text-success',
          label: this.$t('transational.logs.filters.sent'),
        },
        2: {
          status: 'text-warning',
          label: this.$t('transational.logs.filters.spam'),
        },
        3: {
          status: 'text-danger',
          label: this.$t('transational.logs.filters.bounced'),
        },
      }

      return positions[statusCode] || positions.default
    },

    handlerValueTable(label, value) {
      if (label == 'sent') {
        return this.handleDate(value)
      }
      if (label == 'status') {
        return this.handleStatus(value)
      }
      return value
    },

    isItemAttachmentExpired(attachmentExpirationDateTime) {
      const attachmentExpirationDate = new Date(attachmentExpirationDateTime)
      const dateNow = new Date()

      return attachmentExpirationDate < dateNow
    },

    getFormattedAttachmentSize(attachmentBytes) {
      if (!attachmentBytes) return '-'
      return formatFileSize(attachmentBytes)
    },

    async downloadEmailAttachment(item, attachmentId) {
      if (this.isItemAttachmentExpired(item.attachmentExpirationDatetime)) return

      const attachmentKey = `${item.id}-${attachmentId}`
      try {
        this.$set(this.attachmentLoadingStates, attachmentKey, true)
        const organizationId = this.$route.params.organizationId
        const recipientId = item.id

        const response = await services.downloadTransactionAttachment(organizationId, recipientId, attachmentId)
        const nameFile = getFilenameFromContentDisposition(response.headers['content-disposition'])
        fileDownload(response.data, nameFile, response.headers['content-type'])
      } finally {
        this.$set(this.attachmentLoadingStates, attachmentKey, false)
      }
    },
  },
}
</script>

<style>
.dateInputCustom .form-control[readonly] {
  background-color: white !important;
}
</style>
<style lang="scss" scoped>
.gap-15 {
  gap: 15px;
}
.text-nowrap {
  text-wrap: nowrap;
}
</style>
<style>
.search-padding {
  padding-top: 23px;
}
</style>
